export class RestoreAzureEntraIdRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<AzureEntraIdRestoreEntity>",
            "format": ""
        },
        {
            "name": "excludedConsents",
            "baseName": "excludedConsents",
            "type": "Array<AzureEntraIdRestoreConsent>",
            "format": ""
        },
        {
            "name": "dryRun",
            "baseName": "dryRun",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "conditionalAccessReportOnly",
            "baseName": "conditionalAccessReportOnly",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureEntraIdRequest.attributeTypeMap;
    }
    constructor() {
    }
}
